export type EventTableColumnKey =
  | 'title'
  | 'participantName'
  | 'tableName'
  | 'sectorName'
  | 'clientName'
  | 'siteName'
  | 'theme'
  | 'creationDate'
  | 'deliveryDate'
  | 'completedDate'
  | 'archivedDate'
  | 'authorName'
  | 'status';

export interface EventTableColumnMeta {
  key: EventTableColumnKey;
  labelKey: string;
}

export const EVENTS_TABLE_COLUMNS_META: EventTableColumnMeta[] = [
  { key: 'title',           labelKey: 'common:title' },
  { key: 'participantName', labelKey: 'common:participant' },
  { key: 'deliveryDate',    labelKey: 'common:delivery_date' },
  { key: 'clientName',      labelKey: 'common:client' },
  { key: 'siteName',        labelKey: 'common:site' },
  { key: 'sectorName',      labelKey: 'common:sector' },
  { key: 'tableName',       labelKey: 'common:table' },
  { key: 'theme',           labelKey: 'common:theme' },
  { key: 'creationDate',    labelKey: 'common:creation_date' },
  { key: 'completedDate',   labelKey: 'common:completion_date' },
  { key: 'archivedDate',    labelKey: 'common:archived_date' },
  { key: 'authorName',      labelKey: 'common:author' },
  { key: 'status',          labelKey: 'common:status' },
];
